export function contactBots(listOfBots, selectedBots) {
    return selectedBots.map(id => {
        const bot = listOfBots.find(bot => bot._id === id);
        return { id: id, name: bot ? bot?.details?.botName : "Unknown" };
    });
}